(function (angular) {
    'use strict';

    angular.module('app')
        .service('SurveysApi', surveysApi);

    surveysApi.$inject = [
        '$resource',
        'settings',
        'extendResource',
    ];

    function surveysApi(
        $resource,
        settings,
        extendResource,
    ) {
        const resource = $resource(settings.apiBase + '/surveys/:id', {id: '@id'}, {
            update: {
                method: 'PUT',
            },
            post: {
                method: 'POST',
                responseType: 'json',
            },
            delete: {
                method: 'DELETE',
            },
        });

        return extendResource(resource);
    }

}(angular));
